var exports = {
  "P": "x4ddf2309--cc39a2--index",
};

module.exports = exports;
